import React, { useRef } from 'react';
import { Hero } from './components/Hero';
import { QuizExperience } from './components/QuizExperience';
import { Footer } from './components/Footer';
interface AppProps {
  webinarUrl?: string;
  youtubeUrl?: string;
  instagramUrl?: string;
}
export function App({
  webinarUrl = '#webinar',
  youtubeUrl = 'https://youtube.com/@soyfreddypimentel',
  instagramUrl = 'https://www.instagram.com/soyfreddypimentel'
}: AppProps) {
  const testRef = useRef<HTMLDivElement>(null);
  function handleStart() {
    testRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
  return <div className="flex min-h-full w-full flex-col bg-hueso" data-id="element-0" data-mp="31ayqe1uk3nza">
      <Hero onStart={handleStart} data-id="element-1" data-mp="31cjk5p91r2w3" />
      <main className="flex-1" data-id="element-2" data-mp="2wjqft2hhpwkj">
        <div ref={testRef} data-id="element-3" data-mp="2wip6b2g4hi4x">
          <QuizExperience webinarUrl={webinarUrl} data-id="element-4" data-mp="28ufpkexrnkkn" />
        </div>
      </main>
      <Footer youtubeUrl={youtubeUrl} instagramUrl={instagramUrl} data-id="element-5" data-mp="28skzynbjv4a8" />
    </div>;
}